import React, { useState } from 'react';
import { Box, Container, Typography, Grid, TextField, Button, Paper, Snackbar, Alert } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SendIcon from '@mui/icons-material/Send';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [openSnackbar, setOpenSnackbar] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // TODO: Wire this up to the backend or EmailJS
        console.log('Form submitted:', formData);
        setOpenSnackbar(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
    };

    return (
        <Box sx={{ py: 8, bgcolor: '#f4f6f8', minHeight: '80vh' }}>
            <Container maxWidth="lg">
                <Typography variant="h2" align="center" gutterBottom sx={{ fontWeight: 800, mb: 6 }}>
                    Get in Touch
                </Typography>

                <Grid container spacing={6}>
                    {/* Contact Info */}
                    <Grid item xs={12} md={5}>
                        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', gap: 4 }}>
                            <Paper elevation={0} sx={{ p: 4, borderRadius: 4, bgcolor: 'primary.main', color: 'white' }}>
                                <Typography variant="h5" gutterBottom sx={{ fontWeight: 700 }}>
                                    Contact Information
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 4, opacity: 0.9 }}>
                                    Have questions about our programs or want to book a session? We'd love to hear from you.
                                </Typography>

                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                    <EmailIcon sx={{ mr: 2, fontSize: 30 }} />
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>Email Us</Typography>
                                        <Typography variant="h6">hello@earlyedunook.com</Typography>
                                    </Box>
                                </Box>

                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <LocationOnIcon sx={{ mr: 2, fontSize: 30 }} />
                                    <Box>
                                        <Typography variant="subtitle2" sx={{ opacity: 0.8 }}>Visit Us</Typography>
                                        <Typography variant="h6">Mill Creek, WA</Typography>
                                    </Box>
                                </Box>
                            </Paper>

                            <Paper elevation={0} sx={{ p: 4, borderRadius: 4, bgcolor: 'white' }}>
                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 700, color: 'text.primary' }}>
                                    Office Hours
                                </Typography>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography color="text.secondary">Monday - Friday</Typography>
                                    <Typography fontWeight="bold">9:00 AM - 5:00 PM</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography color="text.secondary">Saturday</Typography>
                                    <Typography fontWeight="bold">10:00 AM - 2:00 PM</Typography>
                                </Box>
                            </Paper>
                        </Box>
                    </Grid>

                    {/* Contact Form */}
                    <Grid item xs={12} md={7}>
                        <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
                            <Typography variant="h5" gutterBottom sx={{ fontWeight: 700, mb: 3 }}>
                                Send us a Message
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Your Name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Your Email"
                                            name="email"
                                            type="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Subject"
                                            name="subject"
                                            value={formData.subject}
                                            onChange={handleChange}
                                            required
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            label="Message"
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                            multiline
                                            rows={6}
                                            variant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            size="large"
                                            fullWidth
                                            endIcon={<SendIcon />}
                                            sx={{ py: 1.5, fontWeight: 'bold' }}
                                        >
                                            Send Message
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Paper>
                    </Grid>
                </Grid>

                <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
                    <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                        Message sent successfully! We'll get back to you soon.
                    </Alert>
                </Snackbar>
            </Container>
        </Box>
    );
};

export default ContactPage;
